<template>
  <b-form-select id="gender" v-model="gender" :options=options autocomplete="sex"/>
</template>
<script>
export default {
  name: 'FormOptionState',
  props: ['gender'],
  data: function () {
    return {
      options: [
        {value: 'female', text: 'Frau'},
        {value: 'male', text: 'Herr'}
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/misc/FormOptionGender.vue